import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { SvgIcon } from '@/components/SvgIcon';
import { LANDING_LINKS } from '@/config/landing-links';

import styles from './FooterRegulatoryFramework.module.sass';

export const FooterRegulatoryFramework = () => {
  const { t } = useTranslation();

  return (
    <nav className={styles.regulatory}>
      <Link
        to={LANDING_LINKS.USER_AGREEMENT_PDF_URL}
        rel="noreferrer nofollow"
        target="_blank"
        className={styles.link}
      >
        <SvgIcon name="pdf" />
        <span>{t('translation.landingFooter.userAgreement')}</span>
      </Link>

      <Link
        to={LANDING_LINKS.PRIVACY_POLICY_PAGE_URL}
        rel="noreferrer nofollow"
        target="_blank"
        className={styles.link}
      >
        {t('translation.landingFooter.privacyPolicy')}
      </Link>
    </nav>
  );
};
